import { Card } from '@atomic/atm.card';
import React from 'react';
import { AuthCardStyled } from './auth-card.component.styled';
export const AuthCard = (props) => {
    return (React.createElement(AuthCardStyled, null,
        React.createElement(Card, null, props.children)));
};
